import React, { useState } from 'react';
import { CardComponentProps } from '@/lib/cards';

const FILTER_EVENT = 'catty:users-filter-changed';

/**
 * Users Search & Filter Card
 * Provides search and filter controls for users listing
 */
export const SearchFilterCard: React.FC<CardComponentProps> = ({
  card,
  userContext,
  onError,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterTier, setFilterTier] = useState<string>('');
  const [isSearching, setIsSearching] = useState(false);

  const dispatchFilter = (q: string, tier: string) => {
    window.dispatchEvent(
      new CustomEvent(FILTER_EVENT, {
        detail: { q: q || undefined, tier: tier || undefined },
      }),
    );
  };

  const handleSearch = () => {
    setIsSearching(true);
    dispatchFilter(searchTerm, filterTier);
    setIsSearching(false);
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setFilterTier('');
    dispatchFilter('', '');
  };

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
          Search by name or email
        </label>
        <input
          type="text"
          placeholder="Enter name, email, or ID..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          style={{
            width: '100%',
            padding: '0.5rem',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '0.95rem',
            boxSizing: 'border-box',
          }}
        />
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>
          Filter by tier
        </label>
        <select
          value={filterTier}
          onChange={(e) => setFilterTier(e.target.value)}
          style={{
            width: '100%',
            padding: '0.5rem',
            borderRadius: '4px',
            border: '1px solid #ddd',
            fontSize: '0.95rem',
          }}
        >
          <option value="">All tiers</option>
          <option value="system_admin">System Admin</option>
          <option value="org_admin">Org Admin</option>
          <option value="subscriber">Subscriber</option>
          <option value="member">Member</option>
        </select>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '0.5rem' }}>
        {card.cardActionsList.map((action: string) => (
          <button
            key={action}
            onClick={() => (action === 'Search' ? handleSearch() : handleClearFilters())}
            disabled={isSearching && action === 'Search'}
            style={{
              padding: '0.6rem 1rem',
              backgroundColor: action === 'Search' ? '#0066cc' : '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: isSearching && action === 'Search' ? 'not-allowed' : 'pointer',
              opacity: isSearching && action === 'Search' ? 0.6 : 1,
              fontWeight: 500,
            }}
          >
            {action}
          </button>
        ))}
      </div>
    </div>
  );
};

SearchFilterCard.displayName = 'SearchFilterCard';

export default SearchFilterCard;
